import React, { FC } from "react";
import { Button } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    color: theme.palette.primary.contrastText,
    textDecoration: "none",
  },
  downloadBtn: {
    width: "auto",
    paddingLeft: "0.7rem",
    paddingRight: "0.7rem",
    height: "30px",
    backgroundColor: "#008AFC",
    color: theme.palette.primary.contrastText,
    textTransform: "none",
  },
}));

const DownloadPDF: FC = () => {
  const classes = useStyles();

  return (
    <a
      download="IPD_Analytics_Payer_and_Provider_Insights_Payer.pdf"
      href={process.env.PUBLIC_URL + "/pdf/IPD_Analytics_Payer_and_Provider_Insights_Payer.pdf"}
      className={classes.link}
    >
      <Button variant="contained" size="small" className={classes.downloadBtn}>
        Download the full brochure!
      </Button>
    </a>
  );
};

export default DownloadPDF;
